import { Link } from 'react-router-dom';
import { Instagram, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5675ca92-cfaf-420f-8f00-5e4bce960ecc/artifacts/51x1a7vi_CloneIA-png.png";

const resourceLinks = [
  { to: '/retrouver-information-entreprise', label: 'Retrouver une information' },
  { to: '/retrouver-information-document-entreprise', label: 'Information dans un document' },
  { to: '/perte-information-entreprise', label: 'Perte d\'information' },
  { to: '/centraliser-information-entreprise', label: 'Centraliser l\'information' },
  { to: '/productivite-equipe-outil', label: 'Productivité des équipes' },
  { to: '/clone-collaborateur-entreprise', label: 'Clone collaborateur' },
];

const visionLinks = [
  { to: '/entreprise-interrogeable', label: 'Entreprise interrogeable' },
  { to: '/memoire-entreprise-futur-travail', label: 'Mémoire d\'entreprise' },
  { to: '/blog', label: 'Blog' },
];

const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-white/5 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top section with links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          {/* Logo + Social */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="CloneIA" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-[#71717a] text-sm leading-relaxed mb-4">
              Cloneia rend la mémoire de votre entreprise accessible.
            </p>
            <a 
              href="https://www.instagram.com/cloneia.pro" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex p-2 rounded-full bg-[#1a1a2e]/50 hover:bg-[#3b82f6]/20 transition-colors group"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5 text-[#71717a] group-hover:text-[#3b82f6] transition-colors" />
            </a>
            <a
              href="tel:+33184804884"
              className="inline-flex items-center gap-2 text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm mt-3"
              data-testid="footer-phone"
            >
              <Phone className="w-4 h-4" />
              01 84 80 48 84
            </a>
          </div>

          {/* Ressources */}
          <div data-testid="footer-resources">
            <p className="text-[#f5f5f5] text-sm font-semibold mb-4">Ressources</p>
            <nav className="space-y-2.5">
              {resourceLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm"
                  data-testid={`footer-link-${link.to.slice(1)}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Vision */}
          <div data-testid="footer-vision">
            <p className="text-[#f5f5f5] text-sm font-semibold mb-4">Vision</p>
            <nav className="space-y-2.5">
              {visionLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm"
                  data-testid={`footer-link-${link.to.slice(1)}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Legal */}
          <div>
            <p className="text-[#f5f5f5] text-sm font-semibold mb-4">Entreprise</p>
            <nav className="space-y-2.5">
              <Link to="/equipe" className="block text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm" data-testid="footer-link-equipe">
                Équipe
              </Link>
              <Link to="/contact" className="block text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm" data-testid="footer-link-contact">
                Contact
              </Link>
              <Link to="/mentions-legales" className="block text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm" data-testid="footer-link-mentions-legales">
                {"Mentions l\u00e9gales"}
              </Link>
              <Link to="/politique-confidentialite" className="block text-[#71717a] hover:text-[#f5f5f5] transition-colors text-sm" data-testid="footer-link-politique-confidentialite">
                {"Politique de confidentialit\u00e9"}
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/5">
          <p className="text-sm text-[#52525b] text-center">
            {new Date().getFullYear()} CloneIA. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
